import { apiClient } from '@/lib/api-client';

export interface Series {
  id: string;
  documentType: 'FACTURA' | 'BOLETA' | 'NOTA_CREDITO' | 'NOTA_DEBITO';
  code: string;
  nextNumber: number;
  active: boolean;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export async function listSeries(): Promise<Series[]> {
  const { data } = await apiClient.get<Series[]>('/series');
  return data;
}

export async function createSeriesApi(input: {
  documentType: Series['documentType'];
  code: string;
  isDefault?: boolean;
}): Promise<Series> {
  const { data } = await apiClient.post<Series>('/series', input);
  return data;
}

export async function updateSeriesApi(
  id: string,
  input: { nextNumber?: number; active?: boolean; isDefault?: boolean },
): Promise<Series> {
  const { data } = await apiClient.patch<Series>(`/series/${id}`, input);
  return data;
}
